module.exports = __webpack_public_path__ + "static/media/coingecko-light.f4c4fe18.svg";